// extracted by mini-css-extract-plugin
export default {"fieldset":"CheckboxGroup_fieldset__hABQG","legend":"CheckboxGroup_legend__HoCtr","item":"CheckboxGroup_item__CVCD2","placeHolderShimmer":"CheckboxGroup_placeHolderShimmer__F94zT"};